module.exports = __webpack_public_path__ + "static/media/bin.80005fe9.svg";